export function trackPageView(path = null) {
  // Google Analytics
  if (window.ga) {
    window.ga("set", "page", path || preparePath());
    window.ga("send", "pageview");
  }
}

export function trackEvent(category, action, label = null, value = null) {
  if (window.ga) {
    window.ga("send", "event", category, action, label, value);
  }
}

function preparePath() {
  return window.location.pathname + window.location.hash.replace("#/", "");
}
